export default "__VITE_ASSET__NO6ArjPE__"